import { Typography } from '@/ui';

const Duplicate = () => (
  <Typography variant="body1">One second please ...</Typography>
);

export default Duplicate;
